import {
  CloudIcon,
  CsvIcon,
  DataSetIcon,
  EntrepriseConnectorIcon,
  ExcelIcon,
  FileIcon,
  GoogleDriveIcon,
  JiraIcon,
  MysqlIcon,
  PdfIcon,
  PostgresqlIcon,
  PptIcon,
  SageIcon,
  SapIcon,
  SlackIcon,
  SqlServerIcon,
  TrelloIcon,
  TxtIcon,
  WordIcon,
} from "@dataone/icons";
import {
  DataSourceType,
  DatabaseType,
  EnterpriseConnectorType,
  FileType,
} from "@dataone/lib";

export interface IDataSource {
  key: string;
  label: string;
  apps: IDataSourceApp[];
  icon?: JSX.Element;
}

export interface IDataSourceApp {
  title: string;
  logo: string;
  icon?: JSX.Element;
  type: DatabaseType | EnterpriseConnectorType | FileType;
  parentType: DataSourceType;
}

export const dataSourcesSelection: IDataSource[] = [
  {
    key: "databases",
    label: "Databases",
    apps: [
      {
        title: "MySQL",
        type: DatabaseType.MYSQL,
        parentType: DataSourceType.DATABASE,
        logo: "",
        icon: <MysqlIcon />,
      },
      {
        title: "PostgreSQL",
        type: DatabaseType.POSTGRESQL,
        parentType: DataSourceType.DATABASE,
        logo: "",
        icon: <PostgresqlIcon />,
      },
      {
        title: "SQL Server",
        type: DatabaseType.SQLSERVER,
        parentType: DataSourceType.DATABASE,
        logo: "",
        icon: <SqlServerIcon />,
      },
    ],
    icon: <DataSetIcon />,
  },
  {
    key: "files",
    label: "Files",
    apps: [
      {
        title: "Excel",
        type: FileType.EXCEL,
        parentType: DataSourceType.FILE,
        logo: "",
        icon: <ExcelIcon />,
      },
      {
        title: "Word",
        type: FileType.WORD,
        parentType: DataSourceType.FILE,
        logo: "",
        icon: <WordIcon />,
      },
      {
        title: "PDF",
        type: FileType.PDF,
        parentType: DataSourceType.FILE,
        logo: "",
        icon: <PdfIcon />,
      },
      {
        title: "CSV",
        type: FileType.CSV,
        parentType: DataSourceType.FILE,
        logo: "",
        icon: <CsvIcon />,
      },
      {
        title: "TXT",
        type: FileType.TXT,
        parentType: DataSourceType.FILE,
        logo: "icon-text",
        icon: <TxtIcon />,
      },
      {
        title: "PPTX",
        type: FileType.PPTX,
        parentType: DataSourceType.FILE,
        logo: "",
        icon: <PptIcon />,
      },
    ],
    icon: <FileIcon />,
  },
  {
    key: "entreprise-connectors",
    label: "Enterprise connector",
    apps: [
      {
        title: "SAP",
        type: DatabaseType.SAP,
        parentType: DataSourceType.DATABASE,
        logo: "",
        icon: <SapIcon />,
      },
      {
        title: "Sage",
        type: DatabaseType.SAGE,
        parentType: DataSourceType.DATABASE,
        logo: "",
        icon: <SageIcon />,
      },
      {
        title: "Jira",
        type: EnterpriseConnectorType.JIRA,
        parentType: DataSourceType.ENTERPRISE_CONNECTOR,
        logo: "",
        icon: <JiraIcon />,
      },
      {
        title: "Trello",
        type: EnterpriseConnectorType.TRELLO,
        parentType: DataSourceType.ENTERPRISE_CONNECTOR,
        logo: "",
        icon: <TrelloIcon />,
      },
      {
        title: "Slack",
        type: EnterpriseConnectorType.SLACK,
        parentType: DataSourceType.ENTERPRISE_CONNECTOR,
        logo: "",
        icon: <SlackIcon />,
      },
    ],
    icon: <EntrepriseConnectorIcon />,
  },
  {
    key: "cloud-storages",
    label: "Cloud storage",
    apps: [
      {
        title: "Google Drive",
        type: FileType.DRIVE,
        parentType: DataSourceType.FILE,
        logo: "",
        icon: <GoogleDriveIcon />,
      },
    ],
    icon: <CloudIcon />,
  },
];

export const joinedDataSourceSelection = dataSourcesSelection.reduce(
  (result: IDataSourceApp[], category) => {
    result.push(...category.apps);
    return result;
  },
  []
);
